import {readString} from 'react-papaparse';

import {MAX_RECORDS} from './constants';

export const parseUsersFile = (file: File): Promise<{email?: string, userId?: number}[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = event => {
            if (event.target) {
                const fileContent = event.target.result as string;
                readString(fileContent, {
                    header: false,
                    dynamicTyping: true,
                    delimiter: ',',
                    skipEmptyLines: true,
                    quoteChar: '"',
                    complete: results => {
                        if (results.errors.length > 0) {
                            reject(results.errors);
                        } else {
                            const data = results.data as (string | number)[][];

                            const headers = data[0]
                                .map(header => (header === null ? '' : header))
                                .map((header: string | number) => header.toString().toLowerCase().trim());
                            const emailIndex = headers.indexOf('email');
                            const userIdIndex = headers.indexOf('id');

                            const records: {email?: string, userId?: number}[] = [];

                            data.slice(1).forEach(row => {
                                if (emailIndex !== -1 && userIdIndex !== -1) {
                                    const email = row[emailIndex] === null ? '' : row[emailIndex].toString().trim();
                                    const userId = row[userIdIndex] === null ? 0 : +row[userIdIndex];

                                    if (userId) {
                                        records.push({userId});
                                    } else if (email) {
                                        records.push({email});
                                    }
                                }
                            });

                            if (records.length) {
                                resolve(records);
                            } else {
                                reject(new Error('File does not contain records with required Email or ID columns.'));
                            }
                        }
                    },
                });
            } else {
                reject(new Error('Event target is null.'));
            }
        };

        reader.onerror = error => {
            reject(error);
        };

        reader.readAsText(file);
    });
};

export const validateUsersFile = (file: File): Promise<boolean> => {
    return new Promise((resolve, reject) => {

        if (file.type !== 'text/csv') {
            reject(new Error('Invalid file type. Please upload a CSV file.'));
        }
        const reader = new FileReader();
        reader.onload = event => {
            if (event.target) {
                const fileContent = event.target.result as string;
                readString(fileContent, {
                    header: false,
                    dynamicTyping: true,
                    delimiter: ',',
                    skipEmptyLines: true,
                    quoteChar: '"',
                    complete: results => {
                        if (results.errors.length > 0) {
                            reject(results.errors);
                        } else {
                            if (!results.data.length) {
                                reject(new Error('The uploaded file cannot be empty.'));
                            }

                            const data = results.data as (string | number)[][];
                            const headers = data[0]
                                .filter(header => header !== null)
                                .map((header: (string | number)) => header.toString().toLowerCase());

                            if (headers.includes('email') || headers.includes('id')) {
                                if (results.data.length > MAX_RECORDS + 1) {
                                    reject(new Error(`The file contains more than ${MAX_RECORDS} records.`));
                                }

                                if (results.data.length === 1) {
                                    reject(new Error('The uploaded file cannot be empty.'));
                                } else {
                                    resolve(true);
                                }
                            } else {
                                reject(new Error('File does not contain required Email or ID columns.'));
                            }
                        }
                    },
                });
            } else {
                reject(new Error('Event target is null.'));
            }
        };

        reader.onerror = error => {
            reject(error);
        };

        reader.readAsText(file);
    });
};
